var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetaccessrole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5261 0.339444C17.5001 0.427788 15.8869 2.09029 15.8869 4.11825C15.8869 5.75573 16.9524 7.14169 18.4237 7.67072V11.6759C18.4237 12.3686 18.9945 12.9355 19.6921 12.9355H22.2289C22.9266 12.9355 23.4974 12.3686 23.4974 11.6759C23.4974 10.9831 22.9266 10.4163 22.2289 10.4163H20.9605V7.67072C22.6602 7.06611 23.8138 5.32796 23.4206 3.36298C23.1288 1.87665 21.8996 0.680521 20.4155 0.403408C20.1127 0.3483 19.8156 0.326823 19.5261 0.339444ZM19.6922 2.85861C20.3898 2.85861 20.9606 3.42543 20.9606 4.11821C20.9606 4.81099 20.3898 5.37781 19.6922 5.37781C18.9945 5.37781 18.4237 4.81099 18.4237 4.11821C18.4237 3.42543 18.9945 2.85861 19.6922 2.85861ZM5.84865 10.6008C6.22318 10.4801 6.6143 10.4179 7.00805 10.4163C7.49728 10.417 7.98178 10.5114 8.43501 10.6943C8.47998 10.7131 8.52458 10.7328 8.56879 10.7534L15.8646 13.9122C17.1584 14.4715 17.7424 15.9746 17.1652 17.2531L16.7911 18.0773L17.2643 18.6923L24.7608 15.2776C25.6677 14.8644 26.739 15.2566 27.1614 16.1534C27.5698 17.0213 27.2247 18.0556 26.3736 18.5078L18.5971 22.6359C17.8234 23.0466 16.9121 23.115 16.0851 22.8278L5.73965 19.2335L0.666016 20.8818V11.8112L5.84865 10.6008Z",
    fill: "#0044c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetaccessrole);
export default __webpack_public_path__ + "static/media/Set access role.4b040f4711e5132e5182747c1a0f7904.svg";
export { ForwardRef as ReactComponent };